import React, { useRef } from "react";
import {
  Box,
  Divider,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

const ROWProvisionalFinalAgreement = ({
  applicantdata,
  roDetails,
  profileData,
  bgDetails,
  paDetails,
  getFeesDetails,
  feeDetails,
}: any) => {
  const today = new Date();
  const day = today.getDate();
  const month = today.toLocaleString("default", { month: "long" });
  const year = today.getFullYear();
  const totalAmount = Array.isArray(feeDetails)
    ? feeDetails?.[0]?.fees?.totalAmount
    : feeDetails?.fees?.totalAmount;

  const rowUtilities = applicantdata?.row_utilities_details || [];

  const chainageDetails = applicantdata?.chainage_Details || [];
  const crossingDetails = applicantdata?.crossing_Details || [];

  // Fallback to old data if new APIs are not available
  const alongData =
    chainageDetails.length > 0
      ? chainageDetails
      : rowUtilities.filter((item: any) => item.type === "ALONG");

  const acrossData =
    crossingDetails.length > 0
      ? crossingDetails
      : rowUtilities.filter((item: any) => item.type === "ACROSS");

  const showAlong =
    applicantdata?.proposed_utility_alignment === "Along the Highway" ||
    applicantdata?.proposed_utility_alignment === "Along & Across the Highway";

  const showAcross =
    applicantdata?.proposed_utility_alignment === "Across the Highway" ||
    applicantdata?.proposed_utility_alignment === "Along & Across the Highway";

  const showEndChainage =
    applicantdata?.proposed_utility_alignment !== "Across the Highway" ||
    applicantdata?.end_chainageKm ||
    applicantdata?.end_chainageM;

  const formatChainage = (km: any, meter: any) => {
    if (km == null || meter == null) {
      return "____";
    }

    return `${km} + ${meter}`;
  };
  return (
    <>
      <Box
        id="license-agreement-section"
        sx={{
          margin: "0 auto",
          paddingTop: "0",
          breakBefore: "page",
          pageBreakBefore: "always",
          textAlign: "justify",
          fontFamily: "Trebuchet MS, Arial, sans-serif !important",

          "& *": {
            fontFamily: "Trebuchet MS, Arial, sans-serif !important",
            fontSize: "18px",
          },
        }}
      >
        <Typography
          variant="h6"
          fontWeight={700}
          align="center"
          sx={{ textDecoration: "underline" }}
          gutterBottom
          mb={3}
          fontSize="inherit"
        >
          AGREEMENT REGARDING GRANTING OF RIGHT OF WAY PERMISSIONS
          <br />
          FOR LAYING UTILITY SERVICES ON NATIONAL HIGHWAYS
        </Typography>

        <Typography sx={{ mb: 2, fontSize: "inherit" }} fontSize="inherit">
          Agreement to lay <b>{applicantdata?.amenity || "____"}</b> from{" "}
          <b>
            {formatChainage(
              applicantdata?.start_chainageKm,
              applicantdata?.start_chainageM,
            )}
          </b>{" "}
          Km{" "}
          {Boolean(showEndChainage) && (
            <>
              to{" "}
              <b>
                {formatChainage(
                  applicantdata?.end_chainageKm,
                  applicantdata?.end_chainageM,
                )}
              </b>{" "}
              Km of
            </>
          )}{" "}
          <b>{applicantdata?.national_highway_number || "____"}</b> land.
        </Typography>
        <Typography sx={{ mb: 2, fontSize: "inherit" }}>
          This Agreement made this <b>{day}</b> day of <b>{month}</b> (month) of{" "}
          <b>{year}</b> (year) between acting in his executive capacity through{" "}
          <b>{paDetails?.[0]?.office_name}</b> {" - "}
          <b>{paDetails?.map((pa: any) => pa?.authority)?.join(" / ")}</b>,{" "}
          <b>{roDetails?.office_name || "____"}</b> {"-"}{" "}
          <b>{applicantdata?.ca_authority}</b> (hereinafter referred to as the
          "Authority" which expression shall unless excluded by or repugnant to
          the context, include his successors in office and assigns) on the one
          part, and M/s{" "}
          <b>{applicantdata?.orgnizations?.[0]?.business_name || "____"}</b> a
          company registered under the Companies Act, 1956 and having its
          Registered Office at{" "}
          <b>
            {applicantdata?.orgnizations?.[0]?.org_address || "____"},{" "}
            {applicantdata?.orgnizations?.[0]?.pincode || "____"}
          </b>{" "}
          (hereinafter called the "Licensee") which expression shall unless
          excluded by repugnant to the context, include his
          successors/administrator assignees on the second part.
        </Typography>
        <Typography sx={{ mb: 2, fontSize: "inherit" }}>
          Whereas the Authority is responsible, inter-alia, for development and
          maintenance of lands in Km{" "}
          <b>
            {formatChainage(
              applicantdata?.start_chainageKm,
              applicantdata?.start_chainageM,
            )}
          </b>
          Km{" "}
          {Boolean(showEndChainage) && (
            <>
              to{" "}
              <b>
                {" "}
                {formatChainage(
                  applicantdata?.end_chainageKm,
                  applicantdata?.end_chainageM,
                )}
              </b>{" "}
            </>
          )}
          of NH No <b>{applicantdata?.national_highway_number || "____"}</b>{" "}
          RoW.
        </Typography>
        <Typography sx={{ mb: 2, fontSize: "inherit" }}>
          Whereas the Licensee proposes to lay{" "}
          <b>{applicantdata?.amenity || "____"}</b> referred to as utility
          services in subsequent paras.
        </Typography>
        <Typography sx={{ mb: 2, fontSize: "inherit" }}>
          Whereas the Licensee has applied to the Authority for permission to
          lay utility services from{" "}
          <b>
            {formatChainage(
              applicantdata?.start_chainageKm,
              applicantdata?.start_chainageM,
            )}
          </b>{" "}
          Km{" "}
          {Boolean(showEndChainage) && (
            <>
              to end Chainage{" "}
              <b>
                {formatChainage(
                  applicantdata?.end_chainageKm,
                  applicantdata?.end_chainageM,
                )}
              </b>{" "}
            </>
          )}
          Km of road/route up to{" "}
          <b>{applicantdata?.national_highway_number || "____"}</b> and from km{" "}
          <b>
            {formatChainage(
              applicantdata?.start_chainageKm,
              applicantdata?.start_chainageM,
            )}
          </b>{" "}
          {Boolean(showEndChainage) && (
            <>
              to km{" "}
              <b>
                {formatChainage(
                  applicantdata?.end_chainageKm,
                  applicantdata?.end_chainageM,
                )}
              </b>{" "}
            </>
          )}
          of road/route up to{" "}
          <b>{applicantdata?.national_highway_number || "____"}</b>.
        </Typography>
        {/* Section A: Utility Services Along NH */}
        {showAlong && (
          <>
            {" "}
            <Typography
              variant="h6"
              fontWeight={700}
              sx={{ mt: 3, mb: 2, fontSize: "inherit" }}
            >
              A. Utility Services Along{" "}
              <b>{applicantdata?.national_highway_number || "____"}</b> :
            </Typography>
            <TableContainer
              component={Paper}
              sx={{ fontSize: "inherit" }}
              // sx={{ mb: 3, border: "1px solid #000" }}
            >
              <Table sx={{ borderCollapse: "collapse", fontSize: "inherit" }}>
                <TableHead>
                  <TableRow>
                    <TableCell
                      sx={{
                        border: "1px solid #000",
                        fontWeight: 700,
                        textAlign: "center",
                        padding: "8px",
                        fontSize: "inherit",
                      }}
                    >
                      Sl No.
                    </TableCell>
                    <TableCell
                      colSpan={2}
                      sx={{
                        border: "1px solid #000",
                        fontWeight: 700,
                        textAlign: "center",
                        padding: "8px",
                        fontSize: "inherit",
                      }}
                    >
                      Chainage <br />
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          alignItems: "center",
                          mt: 0.5,
                          fontSize: "inherit",
                        }}
                      >
                        <Typography sx={{ fontSize: "inherit" }}>
                          from (km)
                        </Typography>
                        <Typography sx={{ fontSize: "inherit" }}>
                          to (km)
                        </Typography>
                      </Box>
                    </TableCell>
                    <TableCell
                      sx={{
                        border: "1px solid #000",
                        fontWeight: 700,
                        textAlign: "center",
                        padding: "8px",
                        fontSize: "inherit",
                      }}
                    >
                      Side <br /> &lt;LHS/RHS&gt;
                    </TableCell>
                    <TableCell
                      sx={{
                        border: "1px solid #000",
                        fontWeight: 700,
                        textAlign: "center",
                        padding: "8px",
                        fontSize: "inherit",
                      }}
                    >
                      Length (km)
                    </TableCell>
                    <TableCell
                      sx={{
                        border: "1px solid #000",
                        fontWeight: 700,
                        textAlign: "center",
                        padding: "8px",
                        fontSize: "inherit",
                      }}
                    >
                      Number of Cables and Dia of protection pipe
                    </TableCell>
                  </TableRow>
                  {/* <TableRow>
                    <TableCell
                      sx={{ border: "1px solid #000", padding: "8px" }}
                    />
                    <TableCell
                      sx={{
                        border: "1px solid #000",
                        fontWeight: 700,
                        textAlign: "center",
                        padding: "8px",
                      }}
                    >
                      From km
                    </TableCell>
                    <TableCell
                      sx={{
                        border: "1px solid #000",
                        fontWeight: 700,
                        textAlign: "center",
                        padding: "8px",
                      }}
                    >
                      To km
                    </TableCell>
                    <TableCell
                      sx={{ border: "1px solid #000", padding: "8px" }}
                    />
                    <TableCell
                      sx={{ border: "1px solid #000", padding: "8px" }}
                    />
                    <TableCell
                      sx={{ border: "1px solid #000", padding: "8px" }}
                    />
                  </TableRow> */}
                </TableHead>
                <TableBody>
                  {alongData.length > 0 ? (
                    alongData.map((item: any, index: number) => (
                      <TableRow key={item.id}>
                        <TableCell
                          sx={{
                            border: "1px solid #000",
                            padding: "8px",
                            fontSize: "inherit",
                          }}
                        >
                          {index + 1}
                        </TableCell>

                        <TableCell
                          sx={{
                            border: "1px solid #000",
                            padding: "8px",
                            fontSize: "inherit",
                          }}
                        >
                          {item.start_chainage_km ?? item.startChainageKm}+
                          {item.start_chainage_m ?? item.startChainageM}
                        </TableCell>

                        <TableCell
                          sx={{
                            border: "1px solid #000",
                            padding: "8px",
                            fontSize: "inherit",
                          }}
                        >
                          {item.end_chainage_km ?? item.endChainageKm}+
                          {item.end_chainage_m ?? item.endChainageM}
                        </TableCell>

                        <TableCell
                          sx={{
                            border: "1px solid #000",
                            padding: "8px",
                            fontSize: "inherit",
                          }}
                        >
                          {item.side}
                        </TableCell>

                        <TableCell
                          sx={{
                            border: "1px solid #000",
                            padding: "8px",
                            fontSize: "inherit",
                          }}
                        >
                          {item.length_km ?? item.lengthKm}
                        </TableCell>

                        <TableCell
                          sx={{
                            border: "1px solid #000",
                            padding: "8px",
                            fontSize: "inherit",
                          }}
                        >
                          {item.cable_pipe_details ?? item.cableDetails}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={6} align="center">
                        No Along Data Available
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </>
        )}

        {/* Section B: Utility Services Across NH */}
        {showAcross && (
          <>
            <Typography
              variant="h6"
              fontWeight={700}
              sx={{ mt: 3, mb: 2, fontSize: "inherit" }}
            >
              {applicantdata?.proposed_utility_alignment ===
              "Along & Across the Highway"
                ? "A."
                : "B."}{" "}
              Utility Services Across{" "}
              <b>{applicantdata?.national_highway_number || "____"}</b>:
            </Typography>

            <TableContainer component={Paper}>
              <Table sx={{ borderCollapse: "collapse" }}>
                <TableHead>
                  <TableRow sx={{ fontSize: "inherit" }}>
                    <TableCell
                      sx={{
                        border: "1px solid #000",
                        fontWeight: 700,
                        textAlign: "center",
                        padding: "8px",
                        fontSize: "inherit",
                      }}
                    >
                      Sl No.
                    </TableCell>
                    <TableCell
                      sx={{
                        border: "1px solid #000",
                        fontWeight: 700,
                        textAlign: "center",
                        padding: "8px",
                        fontSize: "inherit",
                      }}
                    >
                      Chainage of Crossing
                    </TableCell>
                    <TableCell
                      sx={{
                        border: "1px solid #000",
                        fontWeight: 700,
                        textAlign: "center",
                        padding: "8px",
                        fontSize: "inherit",
                      }}
                    >
                      Length (km)
                    </TableCell>
                    <TableCell
                      sx={{
                        border: "1px solid #000",
                        fontWeight: 700,
                        textAlign: "center",
                        padding: "8px",
                        fontSize: "inherit",
                      }}
                    >
                      Number of Cables and Dia of protection pipe
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {acrossData.length > 0 ? (
                    acrossData.map((item: any, index: number) => (
                      <TableRow key={item.id}>
                        <TableCell
                          sx={{
                            border: "1px solid #000",
                            padding: "8px",
                            fontSize: "inherit",
                          }}
                        >
                          {index + 1}
                        </TableCell>

                        {/* Chainage of crossing */}
                        <TableCell
                          sx={{
                            border: "1px solid #000",
                            padding: "8px",
                            fontSize: "inherit",
                          }}
                        >
                          {item.crossing_chainage_km ?? item.crossingChainageKm}
                          +{item.crossing_chainage_m ?? item.crossingChainageM}
                        </TableCell>

                        <TableCell
                          sx={{
                            border: "1px solid #000",
                            padding: "8px",
                            fontSize: "inherit",
                          }}
                        >
                          {item.length_km ?? item.lengthKm}
                        </TableCell>

                        <TableCell
                          sx={{
                            border: "1px solid #000",
                            padding: "8px",
                            fontSize: "inherit",
                          }}
                        >
                          {item.cable_pipe_details ?? item.cableDetails}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={4} align="center">
                        No Across Data Available
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </>
        )}
        <Typography sx={{ my: 2, fontSize: "inherit" }}>
          And whereas the Authority has agreed to grant such permission for way
          leave on the NH RoW as per terms and conditions hereinafter mentioned.
        </Typography>
        <Typography sx={{ mb: 2, fontSize: "inherit" }}>
          Now this agreement witnesseth that in consideration of the conditions
          hereinafter contained and on the part of the Licensee to be observed
          and performed, the Authority hereby grants to the Licensee permission
          to lay utility services as per the approved drawing attached hereto
          subject to the following conditions, namely.
        </Typography>
        <Box component="ol" sx={{ pl: 3, mb: 2 }}>
          <li>
            RoW permissions are only enabled in nature. The purpose of extending
            the way leave facility on the National Highway RoW is not for
            enhancing the scope of activity of a utility service provider,
            either by content or by intent. Further, enforceability of the
            permission so granted shall be restricted only to the extent of
            provisions/scope of activities defined in the license agreement &
            for the purpose for which it is granted.
          </li>
          <li>
            No Licensee shall claim exclusive right on the RoW and any
            subsequent user will be permitted to use the RoW, either above or
            below, or by the side of the utilities laid by the first user,
            subject to technical requirements being fulfilled. Decision of the
            Authority in relation to fulfilment of technical requirements shall
            be final and binding on all concerned parties. In case any
            disruption/damage is caused to any existing user by the subsequent
            user, the Authority shall not be held accountable or liable in any
            manner.
          </li>
          <li>
            The Licensee shall be responsible for undertaking all activities
            including, but not limited to site identification, survey, design,
            engineering, arranging finance, project management, obtaining
            regulatory approvals & necessary clearances, supply of equipment,
            material, construction, erection, testing and commissioning,
            maintenance and operation and all other activities essential or
            required for efficient functioning of their own utility/ industrial
            infrastructure facilities.
          </li>
          <li>
            The Licensee shall pay license fees @ Rs <b>{totalAmount ?? "0"}</b>{" "}
            to the Authority. The License fee shall become payable from the date
            of handing over of RoW land to the Licensee, for laying of
            utilities/cables/conduits/pipelines for infrastructure/ service
            provider. As regards Tariff and Terms and conditions for providing
            common utility ducts along National Highways, there shall be a
            separate agreement regime.
          </li>
          <li>
            Fee shall have to be paid in advance for the period for which
            permission is granted for entering into a license agreement. In case
            of renewal, rate prevailing at the time of renewal shall be charged.
            Delay in deposition of fee shall attract interest @ 15% per annum
            compounded annually.
          </li>
          <li>
            The present policy of the MoRT&H is to provide a 2.00 m wide utility
            corridor on either side of the extreme edge of RoW. In cases where
            utility ducts with sufficient space are already available along NH,
            the utility services shall be laid in such ducts subject to
            technical requirements being fulfilled.
          </li>
          <li>
            The utility services shall be laid at the edge of the RoW. In case
            of restricted width of RoW, which may be adequate only to
            accommodate the carriageway, central verge, shoulders, slopes of
            embankment, drains, other road side furniture etc; the utility
            services shall be laid beyond the toe line of the embankments and
            clear of the drain.
          </li>
          <li>
            The Licensee shall make his own arrangement for crossing of cross
            drainage structure, rivers, etc. below the bed. In case, this is not
            feasible, the utility services may be carried outside the
            railings/parapets and the bridge superstructure. The fixing and
            supporting arrangement with all details shall be required to be
            approved in advance from the concerned Highway Administration.
            Additional cost on account of fixing and supporting arrangement as
            assessed by the Authority shall be payable by the Licensee.
          </li>
          <li>
            In exceptional cases, where RoW is restricted the utility services
            can be allowed beneath the carriageway of service road, if
            available, subject to the condition that the utility services be
            laid in concrete ducts, which will be designed to carry traffic on
            top. The width of the duct shall not be less than one lane. In such
            cases, it also needs to ensure that maintenance of the utility
            services shall not interfere with the safe and smooth flow of
            traffic. The cost of operation and maintenance will have to be borne
            by the Licensee.
          </li>
          <li>
            It is to be ensured that at no time there is interference with the
            drainage of the road land and maintenance of the National Highways.
            Towards this, the top of the utility services shall be at least 0.6
            metre below the ground level. However, any structure above ground
            shall be aesthetically provided for / landscaped with required
            safety measures as directed by the concerned Authority;
          </li>
          <li>
            The utility services shall be permitted to cross the National
            Highway either through structure or conduits specially built for
            that purpose. The casing / conduit pipe should, as minimum, extend
            from drain to drain in cuts and toe of slope to toe of slope in the
            fills and shall be designed in accordance with the provision of IRe
            and executed following the Specifications of the Ministry.
          </li>
          <li>
            Existing drainage structures shall not be allowed to carry the lines
            across.
          </li>
          <li>
            The top of the casing/conduit pipe containing the utility services
            to cross the road shall be at least 1.2m below the top of the sub
            grade or the existing ground level whichever is lower, subject to
            being at lease 0.3m below the drain inverts. A typical sketch
            showing the clearances is given in Attachment-I.
          </li>
          <li>
            The utility services shall cross the National Highway preferable on
            a line normal to it or as nearly so as practicable.
          </li>
          <li>
            The casing/conduit pipe for crossing the road may be installed under
            the road embankment either by boring or digging a trench.
            Installation by boring method shall be preferred.
          </li>
          <li>
            In case of trenching, the sides of the trench should be done as
            nearly vertical as possible. The trench width should be at least 30
            em. but not more than 60 ems wider than the outer diameter of the
            pipe. Filling of the trench shall conform to the specifications
            contained here-in-below or as supplied by the Highway Authority.
            <ol
              type="a"
              style={{ listStyleType: "lower-alpha", paddingLeft: "1.25rem" }}
            >
              <li>
                Bedding shall be to a depth not less than 30 cm. It shall
                consist of granular material, free of lumps, clods and cobbles,
                and graded to yield a firm surface without sudden change in the
                bearing value. Unsuitable soil and rock edges should be
                excavated and replaced by selected material.
              </li>
              <li>
                The backfill shall be completed in two stages (i) Side-fill to
                the level of the top of the pipe (ii) Overfill to the bottom of
                the road crust.
              </li>
              <li>
                The side fill shall consist of granular material laid in 15 ern.
                Layers each consolidated by mechanical tamping and controlled
                addition of moisture to 95% of the Proctor's Density. Overfill
                shall be compacted to the same density as the material that had
                been removed. Consolidation by saturation or pending will not be
                permitted.
              </li>
              <li>
                The road crust shall be built to the same strength as the
                existing crust on either side of the trench or to thickness and
                specifications stipulated by the Highway Authority.
              </li>
            </ol>
          </li>
          <li>
            The Licensee shall ensure making good the excavated trench for
            laying utility services by proper filling and compaction, so as to
            restore the land into the same condition as it was before digging
            the trench, clearing debris/loose earth produced due to execution of
            trenching at least 50 m away from the edge of the right of way.
          </li>
          <li>
            All required restoration work subsequent to laying of the cable
            shall be required to be undertaken by the Licensee at its cost
            either by itself or through its authorized representative in
            consultation with the Authority as per predetermined time schedule
            and quality standards.
          </li>
          <li>
            Prior to commencement of any work on the ground, a performance Bank
            Guarantee @ Rs.{" "}
            <b>{(getFeesDetails && getFeesDetails?.BankGuarantee) || "___"}</b>{" "}
            {/* per route metre / Rs per sq m */}
            with a validity of one year initially (extendable if required till
            satisfactory completion of work) shall have to be furnished by the
            Licensee to the Authority/its designated agency as a security
            against improper restoration of ground in terms of
            filling/unsatisfactory compaction damages caused to other
            underground installations/utility services & interference,
            interruption, disruption or failure caused thereof to any services
            etc. In case of the Licensee failing to discharge the obligation of
            making good of the excavated trench/other restoration work, the
            Authority shall have a right to make good the damages caused by
            excavation, at the cost of the Licensee and recover the amount by
            forfeiture of the Bank Guarantee.
          </li>
          <li>
            In case, the electronic Performance Bank Guarantee (e-PBG) is
            invoked as mentioned above, the Licensee shall be required to
            replenish and reinstate the required electronic Performance Bank
            Guarantee (e-PBG) within one month of such invoking. In case the
            work contemplated herein is not completed to the satisfaction of the
            Authority, which has granted the permission, within a period of 11
            months from the date of issue of the Bank Guarantee, the Licensee
            shall either furnish a fresh guarantee or extend the guarantee for a
            further period of one year. Notwithstanding this, the Licensee shall
            be liable to pay full compensation to the aggrieved Authority/ its
            designated agency for any damage sustained by them by reason of the
            exercise of the RoW facility.
          </li>
          <li>
            The Licensee shall shift the utility services within 90 days (or as
            specified by the respective Authority) from the date of issue of the
            notice by the concerned Authority to shift/relocate the utility
            services, in case it is so required for the purpose of
            improvement/widening of the road/route/highway or construction of
            flyover/bridge and restore the road/land to its original condition
            at his own cost and risk.
          </li>
          <li>
            The Licensee shall be responsible to ascertain from the respective
            agency in co-ordination with Authority, regarding the location of
            other utilities /underground installations/ facilities etc. The
            Licensee shall ensure the safety and security of already existing
            underground installations/utilities/facilities etc. before
            commencement of the excavation/using the existing cable ducts. The
            Licensee shall procure insurance from a reputed insurance company
            against damages to already existing underground
            installations/utilities/facilities etc.
          </li>
          <li>
            The Licensee shall be solely responsible/ liable for full
            compensation/indemnification of concerned agency / aggrieved
            Authority for any direct, indirect or consequential damage caused to
            them/claims or replacements sought for, at the cost and risk of the
            Licensee. The concerned agency in co-ordination with Authority shall
            also have a right to make good such damages/ recover the claims by
            forfeiture of Bank Guarantee.
          </li>
          <li>
            If the Licensee fails to comply with any condition to the
            satisfaction of the Authority, the same shall be executed by the
            Authority at the cost and risk of the Licensee.
          </li>
          <li>
            Grant of License is subject to the Licensee satisfying (a) minimum
            disruption of traffic and (b) no damage to the highways. As far as
            possible, the Licensee should avoid cutting of the road for crossing
            highway, and other roads and try to carry out the work by trenchless
            technology. In case any damage is caused to the road pavement in
            this process, the Licensee will be required to restore the road to
            the original condition at its cost. If due to unavoidable reasons
            the road needs to be cut for crossing or laying utility services,
            the Licensee has to execute the restoration work in a time bound
            manner at its cost either by itself or through its authorized
            representative in consultation with the Authority as per
            predetermined time schedule and quality standards. In case of the
            Licensee failing to discharge the obligation of making good of the
            excavated trench/other restoration work, the Authority shall have a
            right to make good the damages caused by excavation, at the cost of
            the Licensee and recover the amount by forfeiture of the Bank
            Guarantee.
          </li>
          <li>
            The Licensee shall inform/give a notice to the concerned agency
            designated by the Authority at least 15 days in advance with route
            details prior to digging trenches, for fresh or maintenance/repair
            works. A separate electronic Performance Bank Guarantee (e-PBG) for
            maintenance/repair works shall have to be furnished by the Licensee.
          </li>
          <li>
            Each day, the extent of digging the trenches should be strictly
            regulated so that utility services are laid and trenches filled up
            before the close of the work that day. Filling should be completed
            to the satisfaction of the concerned agency designated by the
            Authority.
          </li>
          <li>
            The licensee shall indemnify the concerned agency in co-ordination
            with Authority, against all damages and claims, if any due to the
            digging of trenches for laying cables/ducts.
          </li>
          <li>
            The permission for laying utility services is granted maximum for 5
            years at a time, which can thereafter be considered for renewal. On
            payment of additional fee at the time of renewal, the permission
            shall automatically be renewed, unless defaults exist. In case of
            renewal, rate prevailing at the time of renewal shall be charged.
            Delay in deposition of fee shall attract interest @ 15% per annum
            compounded annually.
          </li>
          <li>
            The permission shall be valid only for the period it is issued and
            fee deposited. However, the Authority also has a right to terminate
            the permission or to extend the period of Agreement.
          </li>
          <li>
            That the Licensee shall not undertake any work of shifting, repairs
            or alterations to the utility services without prior written
            permission of the concerned agency in co-ordination with the
            Authority.
          </li>
          <li>
            The permission granted shall not in any way be deemed to conveys to
            the Licensee any ownership right or any interest in
            route/road/highway land /property, other than what is herein
            expressly granted. No use of NH RoW will be permitted for any
            purpose other than that specified in the Agreement.
          </li>
          <li>
            During the subsistence of this Agreement, the utility services
            located in highway land / property shall be deemed to have been
            constructed and continued only by the consent and permission of the
            Authority so that the right of the Licensee to the use thereof shall
            not become absolute and indefeasible by lapse of time.
          </li>
          <li>
            The Licensee shall bear the StampDuty charged on this Agreement.
          </li>
          <li>
            Three copies of 'as laid drawings' of utilities (hard and soft
            copies) with geo- tagged photographs and geo-tagged video recordings
            of laying of cables in the trench (with respect to the NH) and after
            complete restoration shall be submitted to the Authority for
            verification and record within a month of completion of works.
          </li>
          <li>
            The Licensee shall allow free access to the Site at all times to the
            authorised representatives of Authority to inspect the Project
            Facilities and to investigate any matter within their Authority, and
            upon reasonable notice, shall provide reasonable assistance
            necessary to carry out their respective duties and functions.
          </li>
          <li>
            The utility services shall not be made operational by the Licensee
            unless a completion certificate to the effect that the utility
            services has been laid in accordance with the approved
            specifications and drawings and the trenches have been filled up to
            the satisfaction of the concerned agency in co-ordination with the
            Authority has been obtained. Notwithstanding anything contained
            herein, this Agreement may be cancelled at any time by Authority for
            breach of any condition of the same and the Licensee shall neither
            be entitled to any compensation for any loss caused to it by such
            cancellation not shall it be absolved from any liability already
            incurred.
          </li>
          <li>
            The Licensee shall ensure adherence to relevant Indian standards and
            follow best industry practices, methods and standards for the
            purpose of ensuring the safe, efficient and economic design,
            construction, commissioning, operation, repair and maintenance of
            any part of the utility lines/industrial infrastructure facilities
            and which practices, methods and standards shall be adjusted as
            necessary, to take account of:
            <ol
              type="a"
              style={{ listStyleType: "lower-alpha", paddingLeft: "1.25rem" }}
            >
              <li>
                operation, repair and maintenance guidelines given by the
                manufacturers,
              </li>
              <li>the requirements of Law,</li>
              <li>the physical conditions at the Site, and</li>
              <li>The safety of operating personnel and human beings.</li>
            </ol>
          </li>
          <li>
            The Licensee shall have to provide safety measures like barricading,
            danger lighting and other necessary caution boards while executing
            the work.
          </li>
          <li>
            While laying utility services, at least one lane of road shall be
            kept open to traffic at all times. In case of single lane roads, a
            diversion shall be constructed. If any traffic diversion works are
            found necessary during the working period such diversion shall be
            provided at the cost of Licensee.
          </li>
          <li>
            After the termination/expiry of the agreement, the Licensee shall
            remove the utility services within 90 days and the site shall be
            brought back to the original condition failing which the Licensee
            will lose the right to remove the utility services. However before
            taking up the work of removal of utility services the Licensee shall
            furnish a Bank Guarantee to the Authority for a period of one year
            for an amount assessed by the Authority as a security for making
            good the excavated trench by proper filling and compaction, clearing
            debris, loose earth produced due to excavation of trenching at least
            50m away from the edge of the RoW.
          </li>
          <li>
            Any disputes in interpretation of the terms and conditions of this
            Agreement or their implementation shall be referred to the redress
            mechanism prevailing in the Ministry and the decision of the redress
            mechanism shall be final and binding on all.
          </li>
          <li>
            For PPP Projects, in case of any financial loss incurred by the
            respective project concessionaires due to such laying/shifting of
            utility services by the Licensee, compensation for the same shall be
            required to be borne by the Licensee in mutual agreement with the
            respective project concessionaires. MoRT&H/ NHAI/ implementing
            authorities for the project shall not be liable to the
            concessionaire in any way in this regard.
          </li>
        </Box>
        <Typography sx={{ mb: 2, fontSize: "inherit" }}>
          This Agreement has been executed electronically and digitally
          authenticated by the Parties, each Party shall retain a digitally
          signed copy of this Agreement.
        </Typography>
        <Typography sx={{ mb: 2, fontSize: "inherit" }}>
          IN WITNESS WHEREOF THE PARTIES HERETO HAVE CAUSED THIS AGREEMENT TO BE
          EXECUTED THROUGH THEIR RESPECTIVE AUTHORISED REPRESENTATIVES THE DAY
          AND THE YEAR FIRST ABOVE WRITTEN.
        </Typography>
        <Divider sx={{ my: 2 }} />
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            fontSize: "inherit",
          }}
        >
          <Box>
            <Typography sx={{ mb: 1, fontSize: "inherit" }}>
              SIGNED SEALED AND DELIVERED FOR AND ON BEHALF OF AUTHORITY.
            </Typography>
            <Typography sx={{ mb: 1, fontSize: "inherit" }}>
              BY SHRI <b>{roDetails?.office_name || "____"}</b> {"-"}{" "}
              <b>{applicantdata?.ca_authority}</b> <br />
              {/* (Signature, name & address with stamp) */}
            </Typography>
          </Box>
          <Box>
            <Typography sx={{ mb: 1, fontSize: "inherit" }}>
              SIGNED ON BEHALF OF M/S{" "}
              <b>{applicantdata?.orgnizations?.[0]?.business_name || "__"}</b>{" "}
              (LICENSEE)
            </Typography>

            <Typography sx={{ mb: 1, fontSize: "inherit" }}>
              BY SHRI <b>{applicantdata?.user?.applicant_name || "____"} </b>
              <br />
              {/* (Signature, name & address with stamp) */}
            </Typography>
          </Box>
        </Box>
        {/* <Typography sx={{ mb: 1 }}>
          HOLDER OF GENERAL POWER OF ATTORNEY DATED <mark>_____</mark>{" "}
          <mark>_____</mark> <mark>_____</mark> .
        </Typography>
        <Typography sx={{ mb: 1 }}>
          EXECUTED IN ACCORDANCE WITH THE RESOLUTION NO <mark>_____</mark>{" "}
          <mark>_____</mark> <mark>_____</mark> DATED <mark>_____</mark>{" "}
          <mark>_____</mark>
          <mark>_____</mark> .
        </Typography>
        <Typography sx={{ mb: 1 }}>
          PASSED BY THE BOARD OF DIRECTORS IN THE MEETING HELD ON{" "}
          <mark>_____</mark> <mark>_____</mark> <mark>_____</mark> .
        </Typography> */}
      </Box>
    </>
  );
};

export default ROWProvisionalFinalAgreement;
